import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Alert, AlertService } from '@michelin/theme';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { DealershipService } from 'src/app/shared/services/dealership/dealership.service';

@Component({
    selector: 'app-import-dealership',
    templateUrl: './import-dealership.component.html',
    standalone: false
})
export class ImportDealershipComponent implements OnInit {
  loading = false;
  selectedFile: any;
  automakers: AutomakerDto[] = [];

  formImport: FormGroup = null;

  constructor(
    private readonly dealershipService: DealershipService,
    private readonly automakerService: AutomakerService,
    private readonly alertService: AlertService,
    private readonly formBuilder: FormBuilder
  ) {
    this.formImport = this.formBuilder.group({
      automaker: ['', Validators.required],
      file: ['', Validators.required],
      inactive: [false],
      upperCase: [true],
      specialChar: [true]
    });
  }

  get automaker(): FormControl {
    return this.formImport?.get('automaker') as FormControl;
  }

  selectFile(event: any) {
    this.selectedFile = event.target.files;
    console.log(typeof this.selectedFile);
  }

  companyDisplayName(data: any) {
    return data.company?.tradeName;
  }

  submitForm() {
    this.loading = true;
    this.dealershipService
      .upload(
        this.selectedFile.item(0),
        this.formImport.value.automaker?.id,
        this.formImport.value.inactive,
        this.formImport.value.upperCase,
        this.formImport.value.specialChar
      )
      .subscribe({
        next: (response) => {
          const blob = new Blob([response.body!], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
          if (blob.size === 0) {
            this.alertService.showAlert({ type: 'success', content: 'Arquivo carregado com sucesso.' } as Alert);
          } else {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            const nomeBase = this.getFileNameFromHeader(response.headers) || 'CarDealer_Error_CCs';
            const timestamp = this.getFormatedDateTime();
            a.download = `${nomeBase}_${timestamp}.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
            this.alertService.showAlert({
              type: 'strong',
              content: 'Arquivo processado parcialmente. Verifique os erros no arquivo de retorno.'
            } as Alert);
          }
        },
        complete: () => {
          this.loading = false;
        },
        error: (errorResponse: HttpErrorResponse) => {
          let message = '';
          switch (errorResponse.status) {
            case 415:
              message = 'Extensão do arquivo deve ser xls ou xlsx!';
              break;
            case 422:
              message = 'Nenhum registro encontrado para a montadora!';
              break;
            default:
              message = 'Erro ao processar o arquivo.';
              break;
          }
          this.alertService.showAlert({ type: 'critical', content: message } as Alert);
        }
      })
      .add(() => (this.loading = false));
  }

  private getFileNameFromHeader(headers: any): string | null {
    const contentDisposition = headers.get('Content-Disposition');
    if (!contentDisposition) return null;

    const matches = /filename="([^"]+)"/.exec(contentDisposition);
    return matches && matches[1] ? matches[1] : null;
  }

  private getFormatedDateTime(): string {
    const agora = new Date();
    const data = agora.toISOString().split('T')[0];
    const hora = agora.getHours().toString().padStart(2, '0') + agora.getMinutes().toString().padStart(2, '0');
    return `${data}_${hora}`;
  }

  ngOnInit() {
    this.formImport = this.formBuilder.group({
      automaker: ['', Validators.required],
      file: ['', Validators.required],
      inactive: [false],
      upperCase: [true],
      specialChar: [true]
    });

    this.loading = true;

    this.automakerService
      .findAll()
      .subscribe({
        next: (result) => (this.automakers = result),
        error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao recuperar as informações' } as Alert)
      })
      .add(() => (this.loading = false));
  }

  downloadModelFile() {
    this.loading = true;

    this.dealershipService.downloadModelFile().subscribe({
      next: (response) => {
        const blob = new Blob([response.body!], { type: response.headers.get('Content-Type') || 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const nomeBase = this.getFileNameFromHeader(response.headers) || 'CarDealer_Cadastro_CCs_Modelo';
        const timestamp = this.getFormatedDateTime();
        a.download = `${nomeBase}_${timestamp}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
